/**
 * Read the runtime brand color (set by applyTheme() from the tenant's primary color)
 * as an "R,G,B" string usable in canvas fillStyle/strokeStyle. The Tailwind tokens are
 * defined as `rgb(var(--color-brand-*) / <alpha>)`, so the CSS var holds a space- or
 * comma-separated RGB triplet. Falls back to the default brand purple.
 */
export function brandRgb(varName: string, fallback: string): string {
  if (typeof window === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
  if (!v) return fallback;
  return v.replace(/[\s/]+/g, ',').replace(/,+$/, '');
}

/** Brighter brand shade (accents/highlights). */
export const brandBright = () => brandRgb('--color-brand-bright', '124,58,237');
/** Primary brand shade (deeper). */
export const brandDark = () => brandRgb('--color-brand-dark', '76,56,181');
